import { Link } from "react-router-dom";
import BlogPostLayout from "./BlogPostLayout";
import { getPostBySlug } from "../../lib/blog";

export default function ChenillesProcessionnaires() {
  const post = getPostBySlug("chenilles-processionnaires-danger-traitement");
  return (
    <BlogPostLayout post={post}>
      <p>
        Les <strong>chenilles processionnaires du pin</strong> et du{" "}
        <strong>chêne</strong> sont un problème grandissant en Creuse. Petites
        chenilles marron poilues qui se déplacent en file indienne, elles sont
        classées <strong>nuisibles à la santé humaine</strong> depuis 2022
        (arrêté du 25 avril 2022). Voici ce que vous devez savoir.
      </p>

      <h2>Pourquoi elles sont dangereuses</h2>
      <p>
        Le corps des chenilles est couvert de milliers de <strong>poils
        urticants microscopiques</strong> contenant une toxine (la
        thaumétopoéine). Ces poils se libèrent au moindre contact — ou même
        sous l'effet du vent — et provoquent :
      </p>
      <ul>
        <li>
          <strong>Chez l'humain</strong> — démangeaisons intenses, urticaire,
          conjonctivite, gêne respiratoire, voire choc anaphylactique chez les
          personnes allergiques.
        </li>
        <li>
          <strong>Chez le chien (surtout)</strong> — œdème de la langue,
          nécrose partielle voire perte de la langue si l'animal lèche ou mord
          une chenille. <strong>Urgence vétérinaire absolue.</strong>
        </li>
        <li>
          <strong>Chez le chat</strong> — mêmes symptômes, moins fréquents.
        </li>
      </ul>

      <div className="callout-warn">
        <strong>Attention aux enfants</strong>
        Les chenilles processionnaires se déplacent au sol en file indienne
        (« procession ») au printemps. Un enfant qui les touche par curiosité
        risque une réaction sévère. Éloignez-les et faites intervenir un pro.
      </div>

      <h2>Cycle et périodes à risque</h2>
      <ul>
        <li>
          <strong>Automne-hiver</strong> — les nids soyeux blancs sont visibles
          en haut des pins et chênes. C'est le moment idéal pour intervenir
          par <strong>échenillage manuel</strong>.
        </li>
        <li>
          <strong>Février-mars</strong> — les processions descendent au sol
          pour s'enfouir. Période la plus dangereuse pour humains et animaux.
        </li>
        <li>
          <strong>Été-automne</strong> — les papillons pondent et un nouveau
          cycle démarre. C'est le bon moment pour poser des{" "}
          <strong>éco-pièges à collerette</strong> autour du tronc.
        </li>
      </ul>

      <h2>Les solutions de traitement</h2>
      <ol>
        <li>
          <strong>Échenillage manuel (novembre-janvier)</strong> — coupe et
          incinération des nids d'hiver avec équipement adapté (combinaison,
          masque, sécateur télescopique). C'est la solution la plus radicale.
        </li>
        <li>
          <strong>Éco-piège à collerette</strong> — installé autour du tronc,
          il capture les chenilles pendant leur descente au printemps.
          Efficace, écologique, sans produit chimique.
        </li>
        <li>
          <strong>Pulvérisation biologique (Bacillus thuringiensis)</strong> —
          traitement écologique à faire à l'automne. Bacille naturel qui tue
          uniquement les chenilles.
        </li>
        <li>
          <strong>Pièges à phéromones</strong> — pour capturer les papillons
          mâles en été et casser le cycle de reproduction.
        </li>
      </ol>

      <div className="callout">
        <strong>Notre recommandation</strong>
        Combinez <strong>échenillage d'hiver + éco-piège au printemps</strong> pour
        éradiquer durablement la colonie. Un arbre traité une année reste
        généralement calme les 2 années suivantes.
      </div>

      <h2>Ce qu'il ne faut PAS faire</h2>
      <ul>
        <li>
          <strong>Ne brûlez pas le nid depuis le sol</strong> — les poils
          urticants sont propulsés dans l'air par la chaleur et retombent sur
          vous.
        </li>
        <li>
          <strong>Ne coupez pas l'arbre entier</strong> — les chenilles
          risquent de contaminer davantage la zone.
        </li>
        <li>
          <strong>Ne touchez jamais une chenille</strong>, même morte — les
          poils restent urticants pendant plusieurs semaines après.
        </li>
      </ul>

      <h2>Combien ça coûte en Creuse ?</h2>
      <ul>
        <li>
          <strong>Échenillage d'un arbre</strong> (nids &lt; 10 m) : à partir de{" "}
          <strong>80–150 €</strong>
        </li>
        <li>
          <strong>Pose d'éco-piège</strong> (fourniture + installation) :{" "}
          <strong>60–90 €</strong> par arbre
        </li>
        <li>
          <strong>Traitement en hauteur</strong> (nids &gt; 15 m, nacelle) : sur
          devis
        </li>
      </ul>

      <h2>Pour aller plus loin</h2>
      <p>
        Retrouvez tous nos services sur la page{" "}
        <Link to="/entreprise-nuisibles-creuse">
          entreprise anti-nuisibles Creuse
        </Link>
        , ou consultez notre article sur les{" "}
        <Link to="/conseils/reconnaitre-nid-frelons-asiatiques-creuse">
          nids de frelons asiatiques
        </Link>
        .
      </p>
    </BlogPostLayout>
  );
}
